package com.essntl.core.quickbooks.data

import kotlinx.serialization.Serializable

@Serializable
data class QuickbooksCustomerExistsDto(
    val QueryResponse: QueryResponseDto
) {
    @Serializable
    data class QueryResponseDto(
        val Customer: List<CustomerDto>? = null
    ) {
        @Serializable
        data class CustomerDto(
            val Id: String,
        )
    }
}